module.exports = __webpack_public_path__ + "static/media/manuelle-lymphdrainage-mobile.a58470aa.jpg";